import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { formatDate } from '@/lib/format'

interface PostMetaProps {
    postId: string
    publishedAt: string | null
    readMinutes: string | null
    className?: string
}

/* Publish date and reading time. The reading time is the raw posts.read_minutes value, editable in place. */
export const PostMeta: FC<PostMetaProps> = ({
    postId,
    publishedAt,
    readMinutes,
    className
}): ReactNode => {
    const date = formatDate(publishedAt)
    const hasMinutes = Boolean(readMinutes && readMinutes.trim())

    if (!date && !hasMinutes) return null

    return (
        <p className={cn('flex flex-wrap items-center gap-x-2.5 gap-y-1 text-sm text-muted-foreground', className)}>
            {date && (
                <time dateTime={publishedAt ?? undefined}>
                    {date}
                </time>
            )}

            {date && hasMinutes && <span aria-hidden='true' className='size-1 rounded-full bg-current opacity-60' />}

            {hasMinutes && (
                <span>
                    <span data-mdlfy-cms={`posts:${postId}:read_minutes`}>{readMinutes}</span> min read
                </span>
            )}
        </p>
    )
}
